import { React } from "react";
import timeAgo from "../scripts/functions";
import { IoMdTime } from "react-icons/io";
export default function ListItem(params) {

    return (
        <div className={"list-item"}>
            <img className={'thumbnail'} src={params.item['thumbnail']}  alt=""/>

            <div className="list-content">
                <span className="list-title preview-text uppercase">{params.item['title']}</span>
                <span className=" list-text preview-text" dangerouslySetInnerHTML={{__html: params.item['description']}}></span>
                <span className={'time-ago'}>
                    <IoMdTime size={'15'}/>
                    &nbsp;
                    {timeAgo(params.item['dateCreated'])}
                </span>
            </div>
        </div>
    )
}